async function ComponentCategorySave (componentcategoryid, categoryname, categorydescription, modifiedbyid, deleted) {

    if (
        categoryname.length > 0 && 
        categorydescription.length > 0 && 
        modifiedbyid.length > 0 && 
        deleted.length > 0
    ) {

            let response;

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "54", 
                    "parameters": {
                        "@ComponentCategoryId": componentcategoryid,
                        "@CategoryName": categoryname,
                        "@CategoryDescription": categorydescription,
                        "@ModifiedById": modifiedbyid,
                        "@Deleted": deleted
                    },
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "WebApps", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .then((data) => {
                if (JSON.parse(data.payload).error.length > 0) {            
                    throw Error(JSON.parse(data.payload).error);
                }
                else {
                    response = JSON.parse(data.payload).data; 
                }
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return response;

    }
}
 
export default ComponentCategorySave;